export const INDICATORS_DATA = [
  {
    name: '流量指标',
    items: [
      {
        name: '搜索UV',
        value: 'search_uv',
        tip: '进入搜索结果页的用户',
      },
      {
        name: '搜索次数',
        value: 'search_qtty',
        tip: '搜索结果页中page=1的曝光PV',
      },
      {
        name: '搜索sku件次',
        value: 'search_item_piece',
        tip: 'sku在搜索结果页中曝光一次则加1',
      },
      {
        name: '搜索PV',
        value: 'search_pv',
        tip: '搜索结果页中每曝光1页增加1',
      },
      {
        name: '搜索件次CTR',
        value: 'fo_ctr',
        tip: '点击PV/搜索sku件次',
      },
      {
        name: '点击UV',
        value: 'search_click_uv',
        tip: '点击PV按用户去重',
      },
      {
        name: '点击PV',
        value: 'search_click_pv',
        tip: '搜索结果页坑位中每点击一次则加1',
      },
      {
        name: 'UCTR',
        value: 'fo_uctr',
        tip: '点击PV/搜索UV',
      },
    ],
  },
  {
    name: '出库指标',
    items: [
      {
        name: '出库金额',
        value: 'search_ord_out_ord_amt',
        tip: '出库订单行优惠后金额汇总',
      },
      {
        name: '订单行（出库订单）',
        value: 'search_ord_out_line_ord_qtty',
        tip: '精准路径树、L2_new去作弊，出库口径，父单号+sku去重',
      },
      {
        name: '订单量（出库订单）',
        value: 'search_ord_out_father_ord_qtty',
        tip: '出库订单对子单号进行去重计算',
      },
      {
        name: '出库数量',
        value: 'search_ord_out_ord_item_piece',
        tip: '出库订单行sku件数',
      },
      {
        name: '出库人数',
        value: 'search_ord_out_ord_user_qtty',
        tip: '出库订单行下单用户数',
      },
      {
        name: '客单价（出库订单）',
        value: 'fo_pct',
        tip: '出库金额/出库订单行',
      },
      {
        name: '件单价（出库订单）',
        value: 'fo_search_qtty_pct',
        tip: '出库金额/出库数量',
      },
      {
        name: '搜索CVR（出库订单）',
        value: 'fo_search_cvr',
        tip: '出库订单行/点击PV',
      },
      {
        name: 'UCVR（出库订单）',
        value: 'fo_search_ucvr_out',
        tip: '出库金额/搜索UV',
      },
      {
        name: 'UV价值（出库订单）',
        value: 'fo_uv_value_out',
        tip: '出库订单行/点击PV',
      },
      {
        name: '商品曝光RPM（出库订单）',
        value: 'fo_search_rpm_out',
        tip: '出库金额/搜索PV*1000',
      },
    ],
  },
  {
    name: '交易指标',
    items: [
      {
        name: '成交金额',
        value: 'search_ord_deal_ord_amt',
        tip: '在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。',
      },
      {
        name: '订单行（成交订单）',
        value: 'search_ord_deal_line_ord_qtty',
        tip: '精准路径树、L2_new去作弊，成交口径，父单号+sku去重',
      },
      {
        name: '订单量（成交订单)',
        value: 'search_ord_deal_father_ord_qtty',
        tip: '成交订单对子单号进行去重计算',
      },
      {
        name: '成交数量',
        value: 'search_ord_deal_ord_item_piece',
        tip: '成交订单行sku件数',
      },
      {
        name: '成交人数',
        value: 'search_ord_deal_ord_user_qtty',
        tip: '成交订单行下单用户数',
      },
      {
        name: '客单价（成交订单）',
        value: 'fo_search_pct_cj',
        tip: '成交金额/成交订单行',
      },
      {
        name: '件单价（成交订单）',
        value: 'fo_search_qtty_pct_cj',
        tip: '成交金额/成交数量',
      },
      {
        name: '搜索CVR（成交订单）',
        value: 'fo_search_cvr_cj',
        tip: '成交订单行/点击PV',
      },
      {
        name: 'UCVR（成交订单）',
        value: 'fo_search_ucvr_cj',
        tip: '成交订单行/搜索UV',
      },
      {
        name: 'UV价值（成交订单）',
        value: 'fo_search_uv_value_cj',
        tip: '成交金额/搜索UV',
      },
      {
        name: '商品曝光RPM（成交订单）',
        value: 'fo_search_rpm_cj',
        tip: '成交金额/搜索PV*1000',
      },
    ],
  },
  {
    name: '体验指标',
    items: [
      {
        name: '平均点击位置',
        value: 'fo_search_avg_click_pos',
        tip: '对所有搜索结果页点击数据中的位置累加求平均',
      },
      {
        name: '平均下单位置',
        value: 'fo_search_avg_order_pos',
        tip: '对所有搜索订单中的位置累计求平均',
      },
    ],
  },
  {
    name: '商品指标',
    items: [
      {
        name: '曝光商品数',
        value: 'search_expose_item_qtty',
        tip: '搜索sku件次按sku去重',
      },
      {
        name: '点击商品数',
        value: 'search_click_item_qtty',
        tip: '点击PV按sku去重',
      },
      {
        name: '成交商品数',
        value: 'search_ord_deal_ord_item_qtty',
        tip: '成交数量按sku去重',
      },
      {
        name: '出库商品数',
        value: 'search_ord_out_ord_item_qtty',
        tip: '出库数量按sku去重',
      },
    ],
  },
];

export const INTEGER = [
  'search_uv',
  'search_pv',
  'search_qtty',
  'search_item_piece',
  'search_click_pv',
  'search_click_uv',
  'search_ord_out_line_ord_qtty',
  'search_ord_out_father_ord_qtty',
  'search_ord_out_ord_item_piece',
  'search_ord_out_ord_user_qtty',
  'search_ord_deal_line_ord_qtty',
  'search_ord_deal_father_ord_qtty',
  'search_ord_deal_ord_item_piece',
  'search_ord_deal_ord_user_qtty',
  'search_expose_item_qtty',
  'search_click_item_qtty',
  'search_ord_deal_ord_item_qtty',
  'search_ord_out_ord_item_qtty',
];
export const PERCENTAGE = [
  'fo_ctr',
  'fo_uctr',
  'fo_search_cvr',
  'fo_search_ucvr_out',
  'fo_search_cvr_cj',
  'fo_search_ucvr_cj',
];
export const ONE_DECIMAL = [
  'search_ord_deal_ord_amt',
  'search_ord_out_ord_amt',
  'fo_pct',
  'fo_search_qtty_pct',
  'fo_uv_value_out',
  'fo_search_rpm_out',
  'fo_search_pct_cj',
  'fo_search_qtty_pct_cj',
  'fo_search_uv_value_cj',
  'fo_search_rpm_cj',
];
export const TWO_DECIMAL = ['fo_search_avg_click_pos', 'fo_search_avg_order_pos'];
